import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { HStack } from "@/components/Layout";

import useAllocationTypeParam from "../-hooks/useAllocationType";
import { getLicenseFormStoreContext } from "../-store/licenseFormStoreContext";

import InnerNavigation from "./-components/InnerNavigation";
import ManualForm from "./-components/ManualForm";
import { ProgressCard } from "./-components/ProgressCard";
import { SearchSchema } from "./-schema/searchSchema";

export const Route = createFileRoute("/_staff/licenses/add/$allocationType/")({
  validateSearch: zodValidator(SearchSchema),
  component: () => <Form />,
});

function Form() {
  const { allocationType } = useAllocationTypeParam();
  const { context } = getLicenseFormStoreContext(allocationType);
  const store = context.createStore();

  return (
    <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <InnerNavigation />
        </div>
        <ManualForm className="grow min-w-[340px]" />
        <div className="shrink-0">
          <ProgressCard />
        </div>
      </HStack>
    </context.Provider>
  );
}
